var exports = {
  "vK": "xdde3148b--fa047e--banner",
  "Kg": "xdde3148b--fa047e--bank-icons",
  "pK": "xdde3148b--fa047e--bank-item",
  "kG": "xdde3148b--fa047e--bank-counter",
  "FR": "xdde3148b--fa047e--button-container",
};

module.exports = exports;
